export default __webpack_public_path__ + "static/media/Slack.85d1d234.md";